// extracted by mini-css-extract-plugin
export default {"container":"style_container__Op7T9","notes":"style_notes__hepe7"};